module.exports = __webpack_public_path__ + "media/images/tmp/hair-2ab7338da6358029e4c44ef3de2adcac.png";